export default __webpack_public_path__ + "static/media/Lato-BlackItalic.822fef37.woff2";